import Placeholder from '../components/Placeholder';

function MachinesPlaceholder() {
  const title = 'Machines';
  const description = 'This section provides a centralized view of the equipment connected to Menard\'s technology ecosystem. Instead of checking individual machines, technicians can quickly see the status of critical systems across the fleet from a single dashboard.'
  const features = [
    'Live visibility of connected equipment',
    'Omnibox health and communication status',
    'Sensor and instrumentation monitoring',
    'GPS system status and connectivity',
    'Telematics and communications health',
    'Alerts for offline systems and abnormal conditions',
    'Quick access to machine details and troubleshooting information',
  ];
  const benefits = 'Whether supporting a machine in the field or monitoring dozens of rigs at once, this dashboard is designed to help our technical teams identify issues faster, reduce downtime, and provide proactive support before problems impact production.'

  return (
    <Placeholder
      title={title}
      description={description}
      features={features}
      benefits={benefits}
    />
  )
}

export default MachinesPlaceholder;